<script lang="ts">
  // UI components
  import * as Table from '$lib/components/ui/table';
  import { Separator } from '$lib/components/ui/separator';

  // RoastLog
  import TCOffset from '$lib/components/settings/TCOffset.svelte';
  import TCTypeToggle from '$lib/components/settings/TCTypeToggle.svelte';
  import { selectedRoaster, selectedDeviceType } from '$lib/PersistedState.svelte';

  const hasTcTypeToggle = $derived(selectedDeviceType.hasTcTypeToggle);

  const updateOffset = (tcNum: number, e: Event) => {
    const target = e.target as HTMLInputElement;
    const floatValue = parseFloat(target.value);

    selectedRoaster.setTempOffset(tcNum, floatValue);
  };
</script>

{#if !hasTcTypeToggle}
  <Separator class="mt-5" />
{/if}

<Table.Root class="mt-5 w-full">
  <Table.Body>
    {#if hasTcTypeToggle}
      <Table.Row>
        <Table.Cell class="w-24">TC Type</Table.Cell>
        <Table.Cell>
          <TCTypeToggle bind:tcType={selectedRoaster.tcSettings.current[0].type} />
        </Table.Cell>
        <Table.Cell>
          <TCTypeToggle
            bind:tcType={selectedRoaster.tcSettings.current[1].type}
            bind:enabled={selectedRoaster.tcSettings.current[1].active}
          />
        </Table.Cell>
        <Table.Cell>
          <TCTypeToggle
            bind:tcType={selectedRoaster.tcSettings.current[2].type}
            bind:enabled={selectedRoaster.tcSettings.current[2].active}
          />
        </Table.Cell>
        <Table.Cell>
          <TCTypeToggle
            bind:tcType={selectedRoaster.tcSettings.current[3].type}
            bind:enabled={selectedRoaster.tcSettings.current[3].active}
          />
        </Table.Cell>
      </Table.Row>
    {/if}

    <Table.Row>
      <Table.Cell class="w-24">Offset</Table.Cell>
      <Table.Cell>
        <TCOffset
          value={selectedRoaster.tcSettings.current[0].offset}
          onUpdate={(e: Event) => updateOffset(0, e)}
        />
      </Table.Cell>
      <Table.Cell>
        <TCOffset
          value={selectedRoaster.tcSettings.current[1].offset}
          onUpdate={(e: Event) => updateOffset(1, e)}
          enabled={selectedRoaster.tcSettings.current[1].active}
        />
      </Table.Cell>
      <Table.Cell>
        <TCOffset
          value={selectedRoaster.tcSettings.current[2].offset}
          onUpdate={(e: Event) => updateOffset(2, e)}
          enabled={selectedRoaster.tcSettings.current[2].active}
        />
      </Table.Cell>
      <Table.Cell>
        <TCOffset
          value={selectedRoaster.tcSettings.current[3].offset}
          onUpdate={(e: Event) => updateOffset(3, e)}
          enabled={selectedRoaster.tcSettings.current[3].active}
        />
      </Table.Cell>
    </Table.Row>
  </Table.Body>
</Table.Root>
